<template>
    <div class="p20" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建报货单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"  v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                v-model="submitForm.productList"
                :thead-config="productConfig">
                 <el-col :span="24" class="ly-product-total">
                    <el-col :span="20">
                        <label>数量: &nbsp;&nbsp;</label> {{totalQuantity}} 
                        <label style="margin-left:30px;">合计: &nbsp;&nbsp;</label> {{totalAmount}} 
                    </el-col>
                </el-col>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 报货单的新增页面
     * @author wxf
     * @time 2017-10-9
     */
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'

    import {mapGetters, mapActions} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyRouterButton
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            ...mapGetters('bill', [
                'copyInfo'
            ]),
            // 总的金额
            totalAmount () {
                let total = 0 
                this.submitForm.productList.forEach(function (el) {
                    // 计算当前行货品的金额
                    el.xiaoji = (parseFloat(el.quantity) * parseFloat(el.price)).toFixed(2) || ''                   
                    // 计算总金额
                    if (el.xiaoji && !isNaN(el.xiaoji)) {
                        total = (parseFloat(total) + parseFloat(el.xiaoji)).toFixed(2)
                    }
                }, this)
                return total
            },
            totalQuantity () {
                let total = 0
                this.submitForm.productList.forEach(function (el) {
                    if (!isNaN(el.quantity)) {
                        total += parseFloat(el.quantity)
                    }
                })
                return total
            }
        },
        data () {
            return {
                num1: "",
                submitLoad: false, // 提交按钮的状态标识
                loading: false,
                submitForm: {
                     productList: []
                } // 提交的表单数据
            }
        },
        mounted () {
            // 有复制数据的时候
            if (this.copyInfo && this.copyInfo.path && this.copyInfo.path === 'checkin') {
                this.queryEditData(this.copyInfo.id)
            } else {
                // 设置UUID
                this.submitForm.uuid = this.$utils.createUUID()
                // 初始设置制作单人
                this.initData()
            }
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'CheckinAdd') {
                    this.$refs['searchForm'].resetForm()
                    this.$refs['productTable'].resetList()
                    // 初始化数据
                    this.initData()
                }
            }
        },
        methods: {
            ...mapActions('bill', [
                'clearCopyInfo'
            ]),

            /**
             * 获取要修改的数据
             */
            queryEditData (id) {
                this.loading = true
                this.$api.queryArr(['api/sanbaoDj', 'edit'], null, [id]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                     // 清空复制
                    this.clearCopyInfo()
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 初始化的数据设置
             */
            initData () {
                // 初始设置制作单人、收胎人
                this.$refs['searchForm'].initBindFormData({
                    shoutai_czr: this.userInfo.name,
                    zhidan_name: this.userInfo.name
                })
            },
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    if (productList && productList.length > 0) {
                        // 货品验证
                        let productMsg = this.validateProduct(productList)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '货品录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.submitLoad = true
                            // 获得得查询的字段
                            this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                            // 表单中写入货品列表
                            this.submitForm['productList'] = productList
                            // 提交数据
                            this.$api.create('api/sanbaoDj',this.submitForm).then((rs) => {
                                this.$alert('数据提交成功', '新增', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.submitLoad = false
                                        // 跳转到详情页面
                                        this.$router.push('/bill/checkin/info/' + rs.id)
                                    }
                                });
                                // 更新UUID
                                this.submitForm.uuid = this.$utils.createUUID()
                            }).catch((error) => {
                                this.submitLoad = false
                                this.$message({
                                    message: error,
                                    type: 'warning'
                                })
                            })
                        }
                    } else {
                        this.$message({
                            message: '请添加货品',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>